<template>
    <div class="container">
        <div class="back-nav" id="back-nav">
            <div class="top_back" @click="goBack"></div>
        </div>
        <div class="section">
            <div class="section-left">
                <div class="nav-top">
                    <div v-for="item in navList" :key="item.id" :class="{ 'left-item': true, 'item-check': item.id == currentId }" @click="navItemChange(item)">
                        <div v-if="item.id == currentId" class="check-line"></div>
                        <span :class="{ 'txt-light': item.isLight }">{{ item.title }}</span>
                    </div>
                </div>
                <div class="nav-bottom">
                    <div v-for="item in navList2" :key="item.id" :class="{ 'left-item': true, 'item-check': item.id == currentId }" @click="navItemChange(item)">
                        <div v-if="item.id == currentId" class="check-line"></div>
                        <span :class="{ 'txt-light': item.isLight }">{{ item.title }}</span>
                    </div>
                </div>
            </div>
            <div class="section-right">
                <MineCenter v-if="currentId == 1"></MineCenter>
                <MyOrder v-else-if="currentId == 2"></MyOrder>
                <div v-else>none</div>
            </div>
        </div>
    </div>
</template>
<script>
import MineCenter from '../MineCenter/index.vue'
import MyOrder from '../MyOrder/index.vue'
import { removeCookieToken } from '@/utils/auth.js'

export default {
    name: 'ProfileModule',
    components: {
        MineCenter,
        MyOrder
    },
    data() {
        return {
            navList: [
                { id: 1, path: '/profile/minecenter', title: '个人中心', isLight: false },
                { id: 2, path: '/profile/myorder', title: '我的订单', isLight: false },
                { id: 3, path: '/profile/contact', title: '在线客服', isLight: false }
            ],
            navList2: [
                { id: 4, path: '/profile/quit', title: '退出登录', isLight: true },
                { id: 5, path: '/profile/logoff', title: '注销', isLight: false }
            ],
            currentId: 1
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler: function(value) {
                if (value.query.id) {
                    this.currentId = value.query.id
                }
            }
        }
    },
    methods: {
        // 为了方便返回，不用path了
        goBack() {
            this.$router.back()

            setTimeout(() => {
                $('.common-bottom').show()
            }, 300)
        },
        navItemChange(item) {
            if (item.id == 2) {
            } else if (item.id == 3) {
                window.open(this.$store.getters.customerLink, '_blank')
                return false
            } else if (item.id == 4) {
                // 退出登录
                this.$NormalDialog.show({
                    title: '温馨提示',
                    msg: '您确定退出当前账号?',
                    style: {},
                    html: '',
                    showConfirm: true,
                    confirmTxt: '确认',
                    confirmFn: () => {
                        this.$store.dispatch('userLogOut')
                        this.$router.push('/')
                    },
                    cancelFn: () => {}
                })
                return
            } else if (item.id == 5) {
                //注销点击
                var that = this
                this.$OffAccountDialog.show(function(res) {
                    that.goLogoutAndClear() // 注销成功、退出到首页
                })
                return
            }
            this.currentId = item.id
        },
        // 直接退出登录、清空数据
        goLogoutAndClear() {
            removeCookieToken()
            this.$store.commit('resetState')
            this.$router.push('/index')
        }
    }
}
</script>
<style lang="less" scoped>
.container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

    .section {
        position: absolute;
        left: 0;
        top: 90px;
        width: 100%;
        height: calc(100% - 90px);
        display: flex;

        .section-left {
            width: 150px;
            height: 100%;
            font-size: @font-size-medium;
            color: @color-txt-normal;
            position: relative;

            .nav-bottom {
                position: absolute;
                bottom: 82px;
                left: 0;
                width: 100%;
            }

            .left-item {
                margin: 0 10px;
                width: 130px;
                height: 50px;
                line-height: 50px;
                border-radius: 10px;
                text-align: center;
                position: relative;

                &:hover {
                    cursor: pointer;
                    color: rgba(255, 255, 255, 0.9);
                }

                .check-line {
                    position: absolute;
                    left: -10px;
                    top: 10px;
                    width: 4px;
                    height: 30px;
                    border-radius: 2px;
                    background: linear-gradient(125deg, #00f14e, #02cb8a);
                }

                .txt-light {
                    color: @main-green-color;
                }
            }

            .item-check {
                color: #fff;
                background-color: @bg-color-1E;
            }
        }

        .section-right {
            flex-grow: 1;
            padding: 0 40px 10px 10px;
        }
    }
}

.back-nav {
    height: 90px;
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: 30px;

    .top_back {
        width: 55px;
        height: 15px;
        background: url(../../../assets/ic_back.png) center/100% no-repeat;

        &:hover {
            cursor: pointer;
            background: url(../../../assets/ic_back_1.png) center/100% no-repeat;
        }
    }
}
</style>
